/**
 * 主题模块 — 统一管理主题色切换
 * 提供 setAccent / getAccent 方法，同步 localStorage、PWA meta、CSS 变量和 React 端
 *
 * 使用示例：
 *   ttx.theme.setAccent('#e14624'); // 应用主题色
 *   ttx.theme.getAccent();          // '#e14624'
 */
window.ttx = window.ttx || {};
ttx.theme = {};

(function () {
    var DEFAULT_COLOR = '#165dff';
    var STORAGE_KEY = 'accent-color';

    /**
     * 获取当前主题色
     * @returns {string} 颜色值（如 #165dff）
     */
    ttx.theme.getAccent = function () {
        try {
            return localStorage.getItem(STORAGE_KEY) || DEFAULT_COLOR;
        } catch (e) {
            return DEFAULT_COLOR;
        }
    };

    /**
     * 设置主题色，同步更新所有相关位置：
     * 1. html[data-color-theme] — CSS 变量
     * 2. <meta name="theme-color"> — PWA 浏览器标题栏/状态栏颜色
     * 3. localStorage — 持久化
     * 4. accentcolorchange 事件 — 通知 React 端更新 Arco ConfigProvider
     * @param {string} color - 颜色值（如 #e14624）
     */
    ttx.theme.setAccent = function (color) {
        if (!color) return;

        var el = document.documentElement;
        if (!el) return;

        // CSS 变量：默认色时清空属性让 CSS 使用 fallback，非默认色写入
        var themeValue = color;
        el.setAttribute('data-color-theme', themeValue);

        // Keep meta[name="theme-color"] unchanged here.
        // The page-level meta tag should stay under static HTML control.

        // 持久化
        try {
            localStorage.setItem(STORAGE_KEY, color);
        } catch (e) {}

        // 通知 React 端（Arco ConfigProvider primaryColor）
        window.dispatchEvent(new CustomEvent('accentcolorchange', { detail: { color: color } }));
    };
})();